<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-crs-info comp bg-white">
        <el-row class="taxes-box two-cols-form ">
            <el-form
                ref="taxesInfo"
                :model="taxesInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24" class="mes-col">
                    <el-col :span="12">
                        <el-form-item label="客户名称：" class="form-text">
                            <div class="text-con">
                                {{ taxesInfo.custfullname }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件类型：" class="form-text">
                            <div class="text-con">
                                {{ $cache.getDict("130008", taxesInfo.certificatetype) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件号码：" class="form-text">
                            <div class="text-con">
                                {{ taxesInfo.certificateno }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="企业税收类型：" class="required" prop="taxesflag">
                            <el-select
                                v-model="taxesInfo.taxesflag"
                                filterable
                                placeholder="请选择企业税收类型"
                            >
                                <el-option
                                    v-for="item in taxesflags"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否存在控制人：" class="required" prop="isexistctler">
                            <el-select
                                v-model="taxesInfo.isexistctler"
                                filterable
                                placeholder="请选择是否存在控制人"
                            >
                                <el-option
                                    v-for="item in Isexistctler"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                            <el-button v-if="taxesInfo.isexistctler=='1'&& $route.query.taxiesinfoid" type="text" v-on:click.once="$router.push({name:'controllist',query:{taxid:'',taxesflag:taxesInfo.taxesflag}})">
                                设置控制人
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民身份：" class="required" prop="taxestype">
                            <el-select
                                v-model="taxesInfo.taxestype"
                                filterable
                                placeholder="请选择税收居民身份"
                                :disabled="oldTax!==''"
                            >
                                <el-option
                                    v-for="item in taxestypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>机构所在地址</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家：" prop="orgcountry" class="required">
                            <el-select v-model="taxesInfo.orgcountry" filterable placeholder="请选择国家" v-on:change="changeOrgcountry">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="taxesInfo.orgcountry==='CN'">
                        <el-form-item label="省份：" prop="orgprovince" class="required">
                            <el-select v-model="taxesInfo.orgprovince" filterable placeholder="请选择省份" v-on:change="changeOrgprovince">
                                <el-option
                                    v-for="item in $cache.getDict('190021')||[]"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="taxesInfo.orgcountry==='CN'">
                        <el-form-item label="城市：" prop="orgcity" class="required">
                            <el-select v-model="taxesInfo.orgcity" filterable placeholder="请选择城市" v-on:change="changeOrgcity">
                                <el-option
                                    v-for="item in cities"
                                    :key="item.cityid"
                                    :label="item.cityname"
                                    :value="item.cityid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="taxesInfo.orgcountry==='CN'">
                        <el-form-item label="县/区：" prop="county" class="required">
                            <el-select v-model="taxesInfo.county" filterable placeholder="请选择县/区">
                                <el-option
                                    v-for="item in counties"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="address" :class="{'required':isChina}">
                            <el-input
                                v-model="taxesInfo.address"
                                placeholder="请输入机构所在地地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮编：" prop="crspostcode" class="required">
                            <el-input
                                v-model="taxesInfo.crspostcode"
                                placeholder="请输入机构所在地邮编"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                </el-card>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>机构所在地址(英文)</span>
                    </div>
                    <div class="mes-col">
                        <el-col :span="12">
                            <el-form-item label="国家：" prop="engorgcountry" class="required">
                                <el-select v-model="taxesInfo.engorgcountry" filterable placeholder="请选择现居地国家（英文或拼音）">
                                    <el-option
                                        v-for="item in enCountrys"
                                        :key="item.subitem"
                                        :label="item.subitem + '('+item.subitemname+')'"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="省份：" prop="engorgprovince" class="required">
                                <el-input
                                    v-model="taxesInfo.engorgprovince"
                                    placeholder="请输入现居地省份（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="城市：" prop="engorgcity" class="required">
                                <el-input
                                    v-model="taxesInfo.engorgcity"
                                    placeholder="请输入现居地城市（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地址：" prop="engaddress" class="required">
                                <el-input
                                    v-model="taxesInfo.engaddress"
                                    placeholder="请输入现居地地址（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                    </div>
                </el-card>
                <el-col v-if="taxe" :span="24" class="mes-col last">
                    <el-col :span="12">
                        <el-form-item label="机构英文名：" prop="orgengname" class="required">
                            <el-input
                                v-model="taxesInfo.orgengname"
                                placeholder="请输入机构英文名"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册国家代码：" prop="regregioncode">
                            <el-select v-model="taxesInfo.regregioncode" filterable placeholder="请选择注册国家">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册地址：" prop="regadress">
                            <el-input
                                v-model="taxesInfo.regadress"
                                placeholder="请输入注册地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民国家/地区：" prop="taxesplace" class="required">
                            <el-select v-model="taxesInfo.taxesplace" filterable placeholder="请选择税收居民国家/地区">
                                <el-option
                                    v-for="item in speCountrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-col :span="12">
                            <el-form-item label="有无纳税人识别号：" prop="tHaveTaxID" class="required">
                                <el-select v-model="taxesInfo.tHaveTaxID" filterable placeholder="请选择有无居民国家/地区纳税人识别号">
                                    <el-option
                                        v-for="item in tHaveTaxIDs"
                                        :key="item.val"
                                        :label="item.text"
                                        :value="item.val"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col v-if="taxesInfo.tHaveTaxID==='1'" :span="12">
                        <el-form-item label="纳税人识别号：" prop="taxesno" class="required">
                            <el-input
                                v-model="taxesInfo.taxesno"
                                placeholder="请输入居民国家/地区纳税人识别号"
                                :maxlength="100"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxesInfo.tHaveTaxID==='0'" :span="12">
                        <el-form-item label="不能提供的原因：" prop="notaxesreason" class="required">
                            <el-select v-model="taxesInfo.notaxesreason" filterable placeholder="请选择不能提供识别号的原因">
                                <el-option
                                    v-for="item in notaxesreasons"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxesInfo.tHaveTaxID==='0' && taxesInfo.notaxesreason==='2'" :span="12">
                        <el-form-item label="未能取得的原因：" prop="nogetreason" class="required">
                            <el-input
                                v-model="taxesInfo.nogetreason"
                                placeholder="请输入未能取得纳税人识别号的原因"
                                :maxlength="128"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="taxesInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="" prop="protocol">
                        <el-checkbox-group v-model="taxesInfo.protocol" class="checkbox-list">
                            <el-checkbox label="1" name="agree">
                                本人确认上述信息的真实、准确和完整性，且当这些信息发生变更时，将在30日内通知贵机构，否则，本人承担由此造成的不利后果。
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="yellow" class="medium" v-on:click="submitInfo('taxesInfo')">
                        提交
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "CrsInfo",
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            taxesInfo: {
                taxesflag: "",
                isexistctler: "",
                taxestype: "",
                orgengname: "",
                orgcountry: "",
                orgprovince: "",
                orgcity: "",
                county: "",
                address: "",
                crspostcode: "",
                engorgcountry: "",
                engorgprovince: "",
                engorgcity: "",
                engaddress: "",
                regregioncode: "",
                regadress: "",
                taxesplace: "",
                tHaveTaxID: "",
                notaxesreason: "",
                checkbox: "",
                taxesno: "",
                investorsbirthday: "",
                iscontroller: "",
                currentprovince: "",
                currentcity: "",
                engcurrentcountry: "",
                engcurrentprovince: "",
                engcurrentcity: "",
                nogetreason: "",
                protocol: []
            },
            checktaxesInfo: {},
            Isexistctler: [{id: "0", name: "不存在"}, {id: "1", name: "存在"}],
            isPwdCheck: false,
            taxId: "", // 传入修改税收居民信息ID
            lock: "", // 是否是没有税收居民信息新增
            taxe: false, // 是否是中国税收居民
            isChina: false, // 是否是居住地在中国
            oldTax: "", // 原税收军民信息
            taxestypes: [],
            taxesflags: [],
            speCountrys: [], // 税收居民国家/地区数据字典
            countrys: [],
            enCountrys: [],
            provinces: [],
            cities:[],
            counties: [],
            cityListObj:{},
            countyListObj:{},
            notaxesreasons: [],
            tHaveTaxIDs: [{ val: "0", text: "无" }, { val: "1", text: "有" }],
            taxestypeOld: "",
            rules: {
                taxestype: [
                    { required: true, message: "请选择税收居民身份", trigger: "change" }
                ],
                taxesflag: [
                    { required: true, message: "请选择企业税收类型", trigger: "change" }
                ],
                isexistctler: [
                    { required: true, message: "请选择控制人", trigger: "change" }
                ],
                orgengname: [
                    { required: true, message: "请输入机构英文名", trigger: "blur" }
                ],
                orgcountry: [
                    { required: true, message: "请选择机构所在地国家/地区", trigger: "change" }
                ],
                orgprovince: [
                    { required: true, message: "请选择机构所在地省", trigger: "change" }
                ],
                orgcity: [
                    { required: true, message: "请选择机构所在地市", trigger: "change" }
                ],
                county: [
                    { required: true, message: "请选择机构所在地县/区", trigger: "change" }
                ],
                crspostcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                engorgcountry: [
                    { required: true, message: "请选择机构所在地国家/地区（英文或拼音）", trigger: "change" },
                ],
                engorgprovince: [
                    { required: true, message: "请输入机构所在省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engorgcity: [
                    { required: true, message: "请机构所在城市", trigger: "change" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engaddress: [
                    { required: true, message: "请机构所在地址", trigger: "change" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcompanyaddress: [
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                nogetreason: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                taxesno: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                protocol: [
                    { required: true, message: "请确认上述信息的真实、准确和完整", trigger: "change" }
                ],
                taxesplace: [
                    { required: true, message: "请选择税收居民国家/地区", trigger: "change" }
                ],
                tHaveTaxID: [
                    { required: true, message: "请选择有无居民国家/地区纳税人识别号", trigger: "change" }
                ],
                notaxesreason: [
                    { required: true, message: "请选择不能提供识别号的原因", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        "taxesInfo.taxestype" (val) {
            if(val==="1"){
                var keys=["orgcountry","orgprovince","orgcity","county","address","crspostcode",
                "engorgcountry","engorgprovince","engorgcity","engaddress","orgengname","regregioncode","regadress",
                "taxesplace","tHaveTaxID","taxesno","notaxesreason","nogetreason"]
                keys.forEach(item=>{
                    this.taxesInfo[item]=""
                })
            }
            if (val !== "2" && val !== "3") {
                this.taxe = false;
            } else {
                if (this.taxesInfo.taxesplace === "CN") {
                    this.taxesInfo.taxesplace = "";
                }
                this.taxe = true;
            }
        },
        "taxesInfo.tHaveTaxID" (val) {
            if (val === "0") {
                this.$set(this.taxesInfo, "taxesno", "");
            } else {
                this.$set(this.taxesInfo, "notaxesreason", "");
                this.$set(this.taxesInfo, "nogetreason", "");
            }
        },
        // "taxesInfo.protocol" (val) {
        //     if (val.length > 0) {
        //         this.taxesInfo.agreement = val.join(",");
        //     } else {
        //         this.taxesInfo.agreement = "";
        //     }
        // }
    },
    created () {
        // 初始化数据字典值
        this.isPwdCheck = this.$cache.getPwdCheck("T3,T4,T5");
        this.cityListObj = this.$cache.get("address")["citylists"] || {};
        this.countyListObj = this.$cache.get("address")["countylists"] || {};
        // this.getTaxesInfo(this.$route.query.taxiesinfoid);
        const info = this.$cache.getUser();
        this.taxesInfo.taxestype = info.taxestype;
        // this.taxesInfo.ctaxesflag = info.taxesflag;
        this.taxesInfo.investorsbirthday = info.birthdate;
        this.taxesInfo.custfullname = info.custfullname;
        this.taxesInfo.certificatetype = info.certificatetype;
        this.taxesInfo.certificateno = info.certificateno;
        this.$set(this.taxesInfo, "isexistctler", info.isexistctler);
        this.$set(this.taxesInfo, "taxesflag", info.ctaxesflag);
        if(this.taxesInfo.orgcountry){
            this.taxesInfo.orgcountry = this.taxesInfo.orgcountry.trim();
        }
        this.$set(this.taxesInfo, "protocol", []);
        this.lock = this.$route.query.lock || "";
        this.oldTax = this.$route.query.tax || "";
        if (this.$route.query.taxiesinfoid) {
            this.getTaxesInfo(this.$route.query.taxiesinfoid);
        }
        this.taxestypes = this.$cache.getDict("120043");
        this.taxesflags = this.$cache.getDict("120042");
        if (this.lock) {
            this.$set(this.taxesInfo, "taxestype", this.oldTax);
            this.taxestypes = this.taxestypes.filter(item => {
                return item.subitem !== "1";
            });
        }
        const _country = this.$cache.getDict("120109");
        let _y = [];
        let _z = [];
        for(let i in _country){
            if(_country[i].subitem === "CN" || _country[i].subitem === "HK" || _country[i].subitem === "MO" || _country[i].subitem === "TW"){
                if(_country[i].subitemname.indexOf("中国") === -1){
                    _country[i].subitemname = "中国" + _country[i].subitemname;
                }
                if(_country[i].subitem === "CN"){
                    _z.unshift(_country[i]);
                }else{
                    _z.push(_country[i]);
                }
                continue;
            }
            _y.push(_country[i]);
        }
        this.countrys = _z.concat(_y);

        this.speCountrys = this.countrys.filter(item => {
            return item.subitem !== "CN";
        });

        this.enCountrys = this.$cache.getDict("120134");
        this.provinces = this.$cache.getDict("190021");
        this.notaxesreasons = this.$cache.getDict("120044");
        this.checktaxesInfo = Object.assign({}, this.taxesInfo);
    },
    methods: {
        validateAddress (rule, value, callback) {
            if (this.isChina) {
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.checktaxesInfo.pwd = _this.taxesInfo.pwd;
            if(JSON.stringify(_this.checktaxesInfo) == JSON.stringify(_this.taxesInfo)) {
                _this.$message({
                    type: "info",
                    message: "表单数据未改变，请勿重复提交"
                });
                return;
            }
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    const way = (_this.lock ||  _this.fn ) ? "POST" : "PUT";
                    if (_this.taxesInfo.taxestype === "1") {
                        _this.taxesInfo.taxesplace = "CN";
                    }
                    _this.taxesInfo.currentprovince=_this.taxesInfo.orgprovince
                    _this.taxesInfo.currentcity =_this.taxesInfo.orgcity
                    _this.taxesInfo.engcurrentcountry=_this.taxesInfo.engorgcountry
                    _this.taxesInfo.engcurrentprovince=_this.taxesInfo.engorgprovince
                    _this.taxesInfo.engcurrentcity=_this.taxesInfo.engorgcity
                    _this.taxesInfo.engccompanyaddress=_this.taxesInfo.engaddress
                    const _x = Object.assign({}, _this.taxesInfo);
                    delete _x.protocol;
                    _x.tradepwd = _this.$util.enc(_x.pwd);
                    delete _x.pwd;
                    _this.$util.request("tax/OrgTaxInfo", _x, way).then(res => {
                        const msg = way === "PUT" ? "修改" : "新增";
                        if (res.data) {
                            const info = _this.$cache.getUser();
                            info.needfillcrs = "0";
                            _this.$store.dispatch("setInfo", info).then(() => {
                                _this.$cache.refreshUser();
                                _this.$message({
                                    type: "success",
                                    // message: msg + "税收居民信息成功" + (_this.fn ? "" : "，3秒后回到安全中心"),
                                    message: res.msg + (_this.fn ? "" : "，3秒后回到信息中心"),
                                    onClose: function () {
                                        if (_this.fn) { _this.$emit("fn-back", true); } else {
                                            _this.$router.push({ name: "orginfo" });
                                        }
                                    }
                                });
                            });
                        } else {
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        getTaxesInfo (id) {
            const _this = this;
            this.$util.request("tax/OrgTaxInfo", { taxiesinfoid: id }).then(res => {
                for (let item in res.data[0]) {
                    res.data[0][item] = res.data[0][item].trim();
                }
                _this.taxesInfo = Object.assign({}, _this.taxesInfo, res.data[0] || {});
                let _obj = {
                };
                _obj = res.data[0];
                _obj.taxesplace = res.data[0].ctaxestype != "1" ? res.data[0].ctaxesplace : "CN";
                _obj.taxesflag = res.data[0].ctaxesflag || "";
                _obj.taxestype = res.data[0].ctaxestype;
                _obj.address = res.data[0].ccompanyaddress.trim();
                _obj.engaddress = res.data[0].engccompanyaddress;
                _obj.nogetreason = res.data[0].cnogetreason;
                _obj.notaxesreason = res.data[0].cnotaxesreason;
                _obj.taxesno = res.data[0].ctaxesno.trim();
                _obj.taxiesinfoid = res.data[0].taxiesinfoid;
                _obj.iscontroller = "0";
                _obj.protocol = [];
                _this.taxesInfo = _obj;
                _this.cities=_this.cityListObj[_this.taxesInfo.orgprovince]
                _this.counties=_this.countyListObj[_this.taxesInfo.orgcity]
                if (_this.taxesInfo.ctaxesno) {
                    this.$set(_this.taxesInfo, "tHaveTaxID", "1");
                } else if (_this.taxesInfo.cnotaxesreason) {
                    this.$set(_this.taxesInfo, "tHaveTaxID", "0");
                }
            });
        },
        changeOrgcountry(val){
            if (val !== "CN") {
                this.isChina = false;
            } else {
                this.isChina = true;
                if(this.$cache.getDict('190021')&&this.$cache.getDict('190021').length){
                    this.taxesInfo.orgprovince=this.$cache.getDict('190021')[0].subitem
                    this.changeOrgprovince(this.taxesInfo.orgprovince)
                }
            }
        },
        changeOrgprovince(val){
            if (val !== "") {
                this.cities=this.cityListObj[val]
                if(this.cities&&this.cities[0]){
                    this.taxesInfo.orgcity=this.cities[0].cityid
                    this.changeOrgcity(this.taxesInfo.orgcity)
                }else {
                    this.taxesInfo.orgcity=""
                }
            }else {
                this.taxesInfo.orgcity=""
            }
        },
        changeOrgcity(val){
            if (val !== "") {
                this.counties =this.countyListObj[val]
                if(this.counties&&this.counties.length){
                    this.taxesInfo.county=this.counties[0].countyid
                }else{
                    this.taxesInfo.county=""
                }
            }else {
                this.taxesInfo.county=""
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-crs-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }
    .taxes-box {
        padding: 30px 30px 45px;

        .box-card {
            margin-bottom: 20px;
            .clearfix {
                font-size: $f16;
                color: $color-a
            }
        }
        .mes-col {
            margin-bottom: 10px;
            &.last {
                margin-bottom: 0;
            }
            .cut-off-line {
                margin: 30px 0 0;
                top: -30px;
                font-size: $f16;
            }
            &.bg {
                background-color: $bg5;
                .cut-off-line {
                    border-color: $border-color9;
                    span {
                        color: $color-b;
                    }
                }
            }
        }
    }
}
</style>
